import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FeedbackIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M20 10H22V16C22 17.6543 20.6543 19 19 19H6.30273L2 21.8682V6C2 4.3457 3.3457 3 5 3H13V5H4.99999C4.44872 5 3.99999 5.44824 3.99999 6V18.1318L5.69726 17H19C19.5513 17 20 16.5518 20 16V10ZM16.8368 8.69513L18.9999 7.55151L21.1631 8.69513L20.7499 6.27283L22.4999 4.55731L20.0815 4.20392L18.9999 2L17.9184 4.20392L15.4999 4.55731L17.2499 6.27283L16.8368 8.69513ZM7.99999 8V10H13V8H7.99999ZM7.99999 14H17V12H7.99999V14Z",
    fill: "currentColor"
  }));
}